import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { deleteItem } from 'cms/utils/Network';
import { ApiHttpService } from 'cms/utils/http/api';

export default function VideoGalleryCategoryController(props) {

  const [categories, setCategories] = useState(null);
  const [loading,setLoading]= useState(false);

  const { isLoading, data, refetch } = useQuery('videoGallerycategories', () =>
    ApiHttpService.loadUserGalleryCategories(),
    {
      onSuccess: (data) => {
        if (data.results) {
          setCategories(data.results)
        }
      },
    }
  );


  

    
  const handleDelete = (e,id) => {
    e.preventDefault();
    setLoading(id);
    deleteItem('api/usergallery/category',id).then(() => {
      refetch()
    });
  }

  const handleEdit = (e,id) => {
    e.preventDefault();
    
  }

  return {
    categories, setCategories,handleDelete,handleEdit
  };;
}
